import * as signalR from '@microsoft/signalr';

export const negotiateSignalR = async (
  hubUrl: string
): Promise<{ url: string; accessToken: string }> => {
  const response = await fetch(
    `${hubUrl}/moodhub/negotiate?negotiateVersion=1`,
    {
      method: 'POST',
      credentials: 'include',
    }
  );
  if (!response.ok) {
    throw new Error(`SignalR negotiate failed: ${response.status}`);
  }
  return response.json();
};

export const createConnection = (
  url: string,
  accessTokenFactory: () => string | Promise<string>
) => {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(url, { accessTokenFactory })
    .withAutomaticReconnect()
    .build();

  return connection;
};

export const startConnection = async (connection: signalR.HubConnection) => {
  try {
    await connection.start();
  } catch (err) {
    console.error('Error while starting connection: ', err);
    setTimeout(() => startConnection(connection), 5000); // Retry connection
  }
};

export const registerOnMessageReceived = (
  connection: signalR.HubConnection,
  methodName: string,
  callback: (user: string, message: string) => void
) => {
  connection.on(methodName, callback);
};

export const unregisterOnMessageReceived = (
  connection: signalR.HubConnection,
  methodName: string
) => {
  connection.off(methodName);
};

export const closeConnection = async (connection: signalR.HubConnection) => {
  try {
    await connection.stop();
  } catch (err) {
    console.error('Error on closing connection: ', err);
  }
};
